module.exports = __webpack_public_path__ + "static/media/naja_danish.59494735.mp3";